import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFilterTimeline: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"filter-timeline, sort"} maskId="square-filled-radius-0-stroke-1-IconFilterTimeline"><path d="M7.00167 4V18.2924L9.49989 15.7929L10.2072 16.4998L6.50186 20.2071L2.79297 16.5002L3.49989 15.7929L6.00167 18.2933V4H7.00167Z" fill="currentColor"/><path d="M11 6V7H21V6H11Z" fill="currentColor"/><path d="M15 17V18H21V17H15Z" fill="currentColor"/><path d="M13 11.5H21V12.5H13V11.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFilterTimeline;
